/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Icon, StyledModal, ModalActions, ButtonGroup, Text, Button } from 'sarsaparilla';
import WatercraftItem from './WatercraftItem';

const propTypes = {
    watercrafts: PropTypes.any,
    handleWatercraftsChange: PropTypes.func,
    permit: PropTypes.object,
    issuance: PropTypes.object,
    maxQuota: PropTypes.number,
    formValidationChange: PropTypes.func,
    validation: PropTypes.shape({}),
    displayValidationError: PropTypes.bool,
};

export default class WatercraftList extends React.Component {
    constructor(props) {
        super(props);
        this.addWatercraft = this.addWatercraft.bind(this);
        this.removeWatercraft = this.removeWatercraft.bind(this);
        this.handleWatercraftChange = this.handleWatercraftChange.bind(this);
        this.onCloseMessageModal = this.onCloseMessageModal.bind(this);
        this.onFormValidate = this.onFormValidate.bind(this);
        this.state = {
            total: 0,
            isMessageModalOpen: false,
            message: null,
            messageTitle: null,
        };
    }

    onFormValidate(isInValid, error, path) {
        if (isInValid) {
            this.props.formValidationChange(`${this.props.issuance.id}_${path}`, error);
        } else {
            this.props.formValidationChange(`${this.props.issuance.id}_${path}`, null);
        }
    }

    onCloseMessageModal() {
        this.setState({
            isMessageModalOpen: false,
            message: null,
            messageTitle: null,
        });
    }

    addWatercraft(e) {
        e.preventDefault();

        const newList = this.props.watercrafts.slice();

        const newCraft = {
            id: newList.length + 1,
            type: '',
            amount: 0,
            removable: true,
        };

        newList.push(newCraft);
        this.props.handleWatercraftsChange(newList);
    }

    removeWatercraft(craftId) {
        const newList = this.props.watercrafts.slice();
        newList.splice(craftId, 1);
        this.props.handleWatercraftsChange(newList);
    }

    handleWatercraftChange(idx, field, input) {
        const newWatercrafts = this.props.watercrafts.map((watercraft) => ({
            ...watercraft,
        }));
        const foundCraft = newWatercrafts[idx];

        if (foundCraft) {
            switch (field) {
                case 'watercraft-amount':
                    foundCraft.amount = input;
                    break;
                case 'watercraft-type':
                    foundCraft.type = input;
                    break;
                default:
                    break;
            }

            const watercraftTotal = this.computeWatercraftTotal(newWatercrafts);
            if (
                watercraftTotal <= this.props.maxQuota ||
                this.props.maxQuota === undefined ||
                this.props.maxQuota === null
            ) {
                this.props.handleWatercraftsChange(newWatercrafts);
            } else if (this.props.maxQuota) {
                this.setState({
                    isMessageModalOpen: true,
                    message: `Watercraft count exceeds maximum allowed of ${this.props.maxQuota}`,
                    messageTitle: 'Error',
                });
            }
        }
    }

    computeWatercraftTotal(watercrafts) {
        return watercrafts.reduce((total, watercraft) => {
            return total + parseInt(watercraft.amount, 10);
        }, 0);
    }

    render() {
        const addWatercraftBtnText = 'Add watercraft';

        const watercraftList = this.props.watercrafts.map((watercraft, index) => (
            <WatercraftItem
                permit={this.props.permit}
                issuance={this.props.issuance}
                key={index}
                watercraft={watercraft}
                index={index}
                handleWatercraftChange={this.handleWatercraftChange}
                removeWatercraft={this.removeWatercraft}
                isRemoveDisabled={this.props.watercrafts.length <= 1}
                onFormValidate={this.onFormValidate}
                validation={this.props.validation}
                displayValidationError={this.props.displayValidationError}
            />
        ));

        return (
            <div>
                <h2 className={'h5'}>Watercraft</h2>
                <p>
                    Enter the type & number of watercraft you will be bringing. You may
                    update this information at any time before the permit is issued.
                </p>
                <div className="rec-nested-wrap">
                    <div className="rec-grid-12-12">
                        <p className="rec-counter">
                            Total Watercraft:{' '}
                            <b>{`${this.computeWatercraftTotal(this.props.watercrafts)} / ${this.props.maxQuota ? this.props.maxQuota : 'Unlimited'}`}</b>
                        </p>
                    </div>
                </div>
                {watercraftList}
                <div className="rec-nested-wrap">
                    <div className="rec-grid-12-12">
                        <button
                            className="rec-button-link add-watercraft-link"
                            onClick={this.addWatercraft}
                        >
                            <Icon iconName="add-circle" /> {addWatercraftBtnText}
                        </button>
                    </div>
                </div>

                <StyledModal
                    shouldShowCloseButton={false}
                    shouldActionsStickInMobile
                    size="md"
                    isOpen={this.state.isMessageModalOpen}
                    heading={this.state.messageTitle}
                    onRequestClose={this.onCloseMessageModal}
                >
                    <Text>{this.state.message}</Text>

                    <ModalActions>
                        <ButtonGroup isFullWidthOnMobile={false} isStretchedToFit>
                            <Button
                                onClick={this.onCloseMessageModal}
                                appearance="tertiary"
                            >
                                Close
                            </Button>
                        </ButtonGroup>
                    </ModalActions>
                </StyledModal>
            </div>
        );
    }
}

WatercraftList.propTypes = propTypes;
